import { useEffect, useState } from "react";
import { useChatContext } from "stream-chat-react";
import { useUnreadFromChannels } from "./useUnreadFromChannels";

export const useChannelMessageCount = ({
  channelId,
}: {
  channelId: string;
}) => {
  const channelUnreadMap = useUnreadFromChannels({
    channelUrls: [channelId],
    queryOptions: { limit: 1, watch: true },
  });
  const { client } = useChatContext();
  const [channelUnreadCount, setChannelUnreadCount] = useState<number>(0);

  useEffect(() => {
    if (Boolean(channelId) && client) {
      const channel = client.channel("messaging", channelId);
      const readSub = channel.on("message.read", () => {
        setChannelUnreadCount(channel.countUnread());
      });
      const newSub = channel.on("message.new", () => {
        setChannelUnreadCount(channel.countUnread() || 0);
      });

      return () => {
        readSub.unsubscribe();
        newSub.unsubscribe();
      };
    }
  }, [client, channelId]);

  if (!client) {
    return null;
  }

  if (!client.user) {
    return null;
  }

  return {
    messages: channelUnreadCount || channelUnreadMap[channelId] || 0,
  };
};
